<template>
  <v-col cols="12">
    <gg-card>
      <gg-card-header >
        Approved Access
        <gg-btn @click="accessDialog = true" tile  color="primary" class="float-right" >
          Invite
          <span class="visually-hidden text-lowercase">button</span>
        </gg-btn>
      </gg-card-header>
      <v-card-text>
        <v-data-table :headers="headersApproved"
                      :items="accessApprovedList"
                      show-expand
                      :expanded.sync="expandedApproved"
                      item-key="id"
                      single-expand
                      :loading="!loaded">
          <v-progress-linear slot="progress" color="green" height="2" indeterminate />

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-iterator :items="item.services" hide-default-footer>
                <template v-slot:default="props">
                  <v-row>
                    <v-col v-for="(serv, index) in props.items"
                           :key="index"
                           cols="12"
                           sm="6"
                           md="3">
                      <v-card>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>
                              Service ID: <router-link :to="manageServiceLink(serv)">{{ serv.id }}</router-link>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Name: <router-link :to="manageServiceLink(serv)">{{ serv.name }}</router-link>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Domain: <router-link :to="manageServiceLink(serv)">{{ serv.domain }}</router-link>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              <gg-btn text @click="callDeleteAccessModal(item.id, serv.id)">
                                Delete Access
                                <span class="visually-hidden text-lowercase">button</span>
                              </gg-btn>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </gg-card>

    <!-- Invite  -->
    <access-invitation-form :opened="accessDialog" @close="accessDialog = false"/>

    <!--  Delete Access  -->
    <delete-access-modal :opened="deleteAccessModal"
                         :account="deleteAccessAccount"
                         :service="deleteAccessService"
                         @close="closeDeleteAccessModal"
    />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { manageServiceLink } from 'Helpers/helpers'
import AccessInvitationForm from 'Components/Profile/Access/Approved/AccessInvitationForm'
import DeleteAccessModal from 'Components/Profile/Access/Approved/DeleteModal'

export default {
  name: 'ApprovedAccess',
  components: {
    AccessInvitationForm,
    DeleteAccessModal
  },
  data: () => ({
    accessDialog: false,
    headersApproved: [
      {
        text: 'Client ID',
        value: 'id',
      },
      {
        text: 'Client Name',
        value: 'name',
      },
      {
        text: 'Client Email',
        value: 'email',
      },
      { text: 'Services', value: 'data-table-expand' },
    ],
    expandedApproved: [],
    loaded: false,
    deleteAccessModal: false,
    deleteAccessAccount: '',
    deleteAccessService: '',
  }),
  computed: {
    ...mapGetters(['accessApprovedList', 'services']),
  },
  created () {
    this.getData()
  },
  methods: {
    ...mapActions(['reportError', 'getAccessList', 'getAccountList']),
    async getData () {
      this.loaded = false
      try {
        await this.getAccountList()
      } catch (e) {
        this.reportError(e)
      }
      this.loaded = true
    },
    manageServiceLink,
    callDeleteAccessModal (accountId, serviceId) {
      this.deleteAccessAccount = accountId
      this.deleteAccessService = serviceId
      this.deleteAccessModal = true
    },
    closeDeleteAccessModal () {
      this.deleteAccessModal = false
      this.deleteAccessAccount = ''
      this.deleteAccessService = ''
    },
  }
}
</script>
